import React, { FunctionComponent } from "react";
import { ChallengeData } from "/src/domain/challenges/ChallengeTeamData";
import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";
import cs from "classnames";

export type ChallengeViewProps = {
  challenge: ChallengeData;
  className?: string;
};

export const ChallengeDescriptionView: FunctionComponent<
  ChallengeViewProps
> = ({ challenge, className }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Card className={cs(classes.root, className)}>
      <CardMedia image={challenge.imgUrl} className={classes.img} />
      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Typography component="h5" variant="h5">
            {challenge.name}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            {challenge.description}
          </Typography>
          <div className={classes.controls}>
            <Button
              variant="contained"
              color="secondary"
              href={challenge.rulesLink}
              className={classes.button}
            >
              {t("rulesLink")}
            </Button>

            {Boolean(challenge.protocolLink) && (
              <Button
                variant="contained"
                color="primary"
                href={challenge.protocolLink}
              >
                {t("protocol")}
              </Button>
            )}
          </div>
        </CardContent>
      </div>
    </Card>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  img: {
    width: "14rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      position: "relative",
      '&:before': {
        content: "''",
        display: "block",
        paddingTop: "67.9%"
      }
    },
  },
  details: {
    flexDirection: "column",
    display: "flex",
  },
  content: {
    flex: "1 0 auto",
  },
  controls: {
    display: "flex",
    paddingTop: "1rem",
  },
  button: {
    marginRight: "1rem",
  },
}));
